module.exports = __webpack_public_path__ + "img/g8.a8082e9d.jpg";